import { useState, useEffect } from 'react';
import { getVersions, VersionsResponse } from '../utils/version';

export const useVersion = () => {
  const [versions, setVersions] = useState<VersionsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    getVersions()
      .then((data) => {
        console.log('!@# data: ', data);
        if (mounted) {
          setVersions(data);
          setError(null);
        }
      })
      .catch((err) => {
        if (mounted) {
          console.error('Error loading versions:', err);
          setError(err.message || 'Failed to load version information');
          // Set partial data if available
          setVersions({ ui: null, api: null, package: null });
        }
      })
      .finally(() => {
        if (mounted) {
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, []);

  return { versions, loading, error };
};

